import { useQuery } from '@tanstack/react-query';
import { api, type Template } from '../api/client';

export function useTemplates() {
  return useQuery<Template[]>({
    queryKey: ['templates'],
    queryFn: () => api.templates.list(),
    staleTime: 5 * 60 * 1000,
  });
}
